export const initScrollToSection = () => {
  const currentUrl = window.location.origin + window.location.pathname;
  const scrollLinks = document.querySelectorAll(
    'li.scrollToSection > a[href^="#"], li.scrollToSection > a[href*="/#"]'
  );

  scrollLinks.forEach((link) => {
    if (link.dataset.scrollBound) return;
    link.dataset.scrollBound = true;

    const linkUrl = new URL(link.href);

    if (linkUrl.origin + linkUrl.pathname === currentUrl) {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const targetId = linkUrl.hash.slice(1);
        const target = document.getElementById(targetId);

        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    }
  });
};
